import { useEffect, useState } from 'react';

interface Props {
  target: number;
  durationMs?: number;
  onLand?: () => void;
  className?: string;
}

// Animated counter — counts up to target with ease-out-expo, fires onLand once.
export function CounterText({ target, durationMs = 2200, onLand, className }: Props) {
  const start = Math.max(0, target - 18);
  const [displayed, setDisplayed] = useState(start);
  const [landed, setLanded] = useState(false);

  useEffect(() => {
    let raf = 0;
    const startTime = performance.now();
    const range = target - start;

    function tick(now: number) {
      const progress = Math.min((now - startTime) / durationMs, 1);
      const eased = progress >= 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      setDisplayed(Math.round(start + range * eased));
      if (progress < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setLanded(true);
        setTimeout(() => onLand?.(), 400);
      }
    }
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);

  return (
    <span
      className={`num-tabular font-extrabold transition-colors duration-500 ${
        landed ? 'text-danger' : 'text-accent'
      } ${className ?? ''}`}
      style={{ fontSize: 'clamp(72px, 18vw, 110px)', lineHeight: 1 }}
    >
      {displayed}
    </span>
  );
}
